import { Language } from '@app/lib/store-context/Context';

export default (language: Language) => {
    if (typeof document === 'undefined') return null;
    const cookieIdentifier = `shopify_cart_id_${language.toLowerCase()}`;
    document.cookie = cookieIdentifier + '=; Max-Age=0; path=/';
};
